import {
    Email, Work,
    Password, Phone,
} from '@mui/icons-material';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Juridical = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('+993');
    const [company, setCompany] = useState('')
    const [password, setPassword] = useState('')
    const [passwordRepaed, setPasswordRepead] = useState('')

    const handlePhoneNumberChange = (e) => {
        let input = e.target.value;
        if (!input.startsWith('+993')) {
            input = '+993' + input.replace(/[^0-9]/g, '');
        } else {
            input = '+993' + input.slice(4).replace(/[^0-9]/g, '');
        }
        if (input.length > 12) {
            input = input.slice(0, 12);
        }
        setPhoneNumber(input);
    };

    const handleSubmit = () => {
        if (!email || !company || !phoneNumber || !password || !passwordRepaed) {
            alert(t('Ähli meýdançany doldyrmak hökmany!'));
        } else {
            alert('Üstünlikli ugradyldy!');
        }
    };

    return (
        <form>

            {/* first row */}
            <div className="relative mt-8">
                <label className='flex items-center gap-1 text-sm
                                 dark:text-dark-text'>
                    <Work style={{ fontSize: '18px', color: '#0039a6' }} />
                    {t('company_name')}
                </label>
                <input
                    type="text"
                    name="company"
                    placeholder={t('company_name')}
                    value={email}
                    onChange={(e) => setCompany(e.target.value)}
                    className="px-4 py-2 border border-border 
                               bg-secondary rounded w-full mt-1
                               focus:outline-none focus:ring-2 mb-2
                               focus:ring-indigo-500 dark:text-white 
                               dark:bg-dark-box dark:border-dark-border"
                />
            </div>

            {/* second row */}
            <div className="mt-4 lg:flex justify-between gap-8">

                {/* Email Input */}
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <Email style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('Email')}
                    </label>
                    <input
                        type="text"
                        name="email"
                        placeholder={t('Email')}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="px-4 py-2 border border-border 
                                   bg-secondary rounded w-full mt-1
                                   focus:outline-none focus:ring-2 mb-2
                                   focus:ring-indigo-500 dark:text-white 
                                   dark:bg-dark-box dark:border-dark-border"
                    />
                </div>

                {/* phone */}
                <div className="lg:w-[50%] relative mt-6 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <Phone style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('phone_number')}
                    </label>
                    <input
                        type="text"
                        name="phone"
                        placeholder={t('phone_number')}
                        value={phoneNumber}
                        onChange={handlePhoneNumberChange}
                        className="w-full px-4 py-2 border dark:text-dark-text
                                  border-border bg-secondary mb-2 mt-1 
                                  rounded focus:outline-none focus:ring-2 
                                  focus:ring-indigo-500 dark:text-white 
                                  dark:bg-dark-box dark:border-dark-border"
                    />
                </div>
            </div>

            {/* third row */}
            <div className="mt-4 lg:flex justify-between gap-8">
                <div className="lg:w-[50%] relative mt-6 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <Password style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('password')}
                    </label>
                    <input
                        type="password"
                        name="phone"
                        placeholder={t('password')}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full px-4 py-2 border dark:text-dark-text
                                  border-border bg-secondary mb-2 mt-1 
                                  rounded focus:outline-none focus:ring-2 
                                  focus:ring-indigo-500 dark:text-white 
                                  dark:bg-dark-box dark:border-dark-border"
                    />
                </div>
                <div className="lg:w-[50%] relative mt-6 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <Password style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('repeat_password')}
                    </label>
                    <input
                        type="password"
                        name="phone"
                        placeholder={t('repeat_password')}
                        value={passwordRepaed}
                        onChange={(e) => setPasswordRepead(e.target.value)}
                        className="w-full px-4 py-2 border dark:text-dark-text
                                  border-border bg-secondary mb-2 mt-1 
                                  rounded focus:outline-none focus:ring-2 
                                  focus:ring-indigo-500 dark:text-white 
                                  dark:bg-dark-box dark:border-dark-border"
                    />
                </div>
            </div>

            <div className='w-full items-center xl:flex gap-2 mt-8 mb-4'>
                <button
                    type="button"
                    className='text-white bg-primary px-6 
                               py-2 rounded'
                    onClick={handleSubmit}
                >
                    {t('create_account')}
                </button>
                <p className='dark:text-dark-text mt-2 xl:mt-0'>
                    {t('have_account')}
                </p>
                <Link to='/auth/login'>
                    <p className='text-primary dark:text-white'>
                        {t('log_in')}
                    </p>
                </Link>
            </div>
            <p className='text-text dark:text-dark-text 
                          text-sm mb-4'>
                {t('please_registration')}
            </p>
        </form>
    )
}

export default Juridical